"use client";

import { createIcon } from "@chakra-ui/react";

const TiktokSvgIcon = createIcon({
  displayName: "TiktokSvgIcon",
  viewBox: "0 0 24 24",
  path: (
    <path xmlns="http://www.w3.org/2000/svg" d="M16.5725 0H12.5278V16.3478C12.5278 18.2957 10.9722 19.8957 9.03626 19.8957C7.10034 19.8957 5.54469 18.2957 5.54469 16.3478C5.54469 14.4348 7.06577 12.8695 8.93257 12.8V8.69567C4.81872 8.7652 1.5 12.1391 1.5 16.3478C1.5 20.5913 4.88786 24 9.07085 24C13.2538 24 16.6416 20.5565 16.6416 16.3478V7.9652C18.1627 9.07827 20.0295 9.73913 22 9.77393V5.66957C18.9579 5.56522 16.5725 3.06087 16.5725 0Z" fill="currentColor"/>
  ),
});

export default TiktokSvgIcon;
